import { ChevronRightIcon } from '@heroicons/react/24/outline'
import cx from 'classix'
import React from 'react'

type Props = {
  text: string
  showArrow: boolean
}

export default function HoverableArrow({ text, showArrow }: Props) {
  const splittedText = text.split(' ')

  return (
    <>
      {splittedText.length > 1 && (
        <span className='whitespace-pre-wrap'>{splittedText.slice(0, -1).join(' ') + ' '}</span>
      )}
      <span className='whitespace-nowrap'>
        {splittedText.slice(-1)}{' '}
        <ChevronRightIcon
          className={cx('inline-block ml-1 w-4 h-4', showArrow ? 'opacity-100' : 'opacity-0')}
        />
      </span>
    </>
  )
}
